import { Button, Image, Radio, Table } from 'antd';
import API from 'API';
import { correct_media } from 'general_function';
import React, { useCallback, useEffect, useMemo, useState } from 'react'

const baseColumns = [
    { title: "Người chúc", key: "name", dataIndex: "name" },
    { title: "Lời chúc", key: "message", dataIndex: "message" },
    { title: "Ảnh", key: "image", dataIndex: "image", render: value => value && <Image width={100} src={correct_media(value)} /> },
    {
        title: "Trạng thái",
        key: "status",
        render: item => !item.is_checked
            ? <span style={{ color: "gray" }}>Chưa duyệt</span>
            : item.is_accepted
                ? <span style={{ color: "green" }}>Đã duyệt</span>
                : <span style={{ color: "red" }}>Đã từ chối</span>
    }
]

export default function WeddingWishReviewPage() {
    const [loading, setLoading] = useState(true);
    const [weddingWishes, setWeddingWishes] = useState([]);
    const [loadingWishes, setLoadingWishes] = useState([]);
    const [filterStatus, setFilterStatus] = useState(0);
    const filterData = useMemo(() => [
        weddingWishes,
        weddingWishes.filter(item => !item.is_checked),
        weddingWishes.filter(item => item.is_accepted),
        weddingWishes.filter(item => item.is_checked && !item.is_accepted),
    ], [weddingWishes])

    useEffect(() => {
        var sending = false;
        var maxId = null;
        function fetchData() {
            if (sending) return;
            sending = true;
            API.get(`wedding-wish-review/${maxId ? `?id=${maxId}` : ""}`)
                .then(res => {
                    if (res.data.length > 0) {
                        setWeddingWishes(weddingWishes => [...res.data, ...weddingWishes]);
                        maxId = res.data[0].id;
                    }
                    setLoading(false);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    sending = false;
                })
        }

        fetchData();
        const interval = setInterval(fetchData, 5000);

        return () => clearInterval(interval);
    }, [])

    const reviewWeddingWish = useCallback((id, accepted) => {
        setLoadingWishes(loadingWishes => [...loadingWishes, id]);
        API.post("wedding-wish-review/", {
            wedding_id: id, accepted: accepted
        })
            .then(res => {
                setWeddingWishes(weddingWishes => {
                    const index = weddingWishes.findIndex(item => item.id === id);
                    weddingWishes[index] = {
                        ...weddingWishes[index],
                        is_checked: true, is_accepted: accepted
                    }
                    return [...weddingWishes];
                })
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setLoadingWishes(loadingWishes => loadingWishes.filter(item => item !== id));
            })
    }, [])

    const columns = useMemo(() => {
        return [
            ...baseColumns,
            {
                key: "action", render: item =>
                    loadingWishes.includes(item.id) ? <span style={{ color: "gray" }}>
                        Đang duyệt...
                    </span>
                        : <>
                            {(!item.is_checked || !item.is_accepted) && (
                                <Button type='primary' style={{ marginRight: 5, minWidth: 90 }}
                                    onClick={() => reviewWeddingWish(item.id, true)}
                                >
                                    Duyệt
                                </Button>
                            )}
                            {(!item.is_checked || item.is_accepted) && (
                                <Button type='primary' danger style={{ minWidth: 90 }}
                                    onClick={() => reviewWeddingWish(item.id, false)}
                                >
                                    Từ chối
                                </Button>
                            )}
                        </>
            }
        ]
    }, [loadingWishes, reviewWeddingWish])

    console.log(filterData[filterStatus])

    return <div style={{ padding: 15 }}>
        <div>
            <Radio.Group 
                value={filterStatus}
                options={[
                    { value: 0, label: `Toàn bộ lời chúc (${filterData[0].length})` },
                    { value: 1, label: `Chưa duyệt (${filterData[1].length})` },
                    { value: 2, label: `Đã duyệt (${filterData[2].length})` },
                    { value: 3, label: `Đã từ chối (${filterData[3].length})` },
                ]}
                onChange={e => setFilterStatus(e.target.value)}
            />
        </div>
        <Table
            key={filterStatus}
            columns={columns}
            dataSource={filterData[filterStatus]}
            loading={loading}
            rowKey="id"
        />
    </div>
}
